import { render, staticRenderFns } from "./audible-alarm.vue?vue&type=template&id=fbec6f7e&scoped=true"
import script from "./audible-alarm.vue?vue&type=script&lang=js"
export * from "./audible-alarm.vue?vue&type=script&lang=js"
import style0 from "./audible-alarm.vue?vue&type=style&index=0&id=fbec6f7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbec6f7e",
  null
  
)

export default component.exports